<div class="order-management-container container-fluid cx-one-ui">
  <!-- HEADERS -->
  <div class="row justify-content-between">
    <div class="col-12 d-flex justify-content-between">
      <div class="font-size-18 order-management-title" cvLocalizedText langSection="Order_Management"
        langKey="OrderManagement">Order
        Management</div>
      <button class="btn cxone-btn btn-big btn-secondary btn-bg-is-white export-btn" tabindex="0" (click)="exportOrdersTable()">
        <svg>
          <use href="../App_Themes/CXone/icons/export.svg#export"></use>
        </svg>
        <span cvLocalizedText langSection="Module_Menu" langKey="Export">Export</span>
      </button>
    </div>
  </div>
  <!-- /HEADERS -->
  <!-- MAIN CONTAINER -->
  <div class="row">
    <div class="col-12">
      <!-- BG COLOR CONTAINER -->
      <div class="container-shadow">
        <!-- FILTER -->
        <!-- omnibar and search bar -->
        <cxone-omnibar #filters class="w-100 order-managment-omnibar" [itemCountLabel]="countOrdersLabel"
          [isFilterable]="true" [searchPlaceholderText]="searchPlaceholder"
          (showFooterChanged)="isFilterOpen = !isFilterOpen"
          (searchQueryChange)="onTitleFilterChange($event)">
          <cxone-omnibar-custom-content
            class="d-flex justify-content-between w-100 align-items-center">
            <div class="d-flex align-items-center w-100">
              <cxone-selected-tags id="selected-status-tags" label="name" class="w-77" [removable]="true"
              [tagsSource]="tagList" [popoverBackgroundColor]="'#F7FAFC'" primaryKey="id" (tagDeleted)="removeTag($event)" />
              <!-- <a class="pr-1" *ngIf="tagList.length > 0" cvLocalizedText langSection="MarketPlace_Management" langKey="Clear_All"
                  (click)="clearFilters()">Clear All</a> -->
            </div>
            <cxone-singleselect-dropdown id="orders-placed-in-dropdown" 
              class="d-block drodpdown-container-timeinterval"
              [label]="'name'" [primaryKey]="'position'" 
              [placeholder]="cvLocalizationService.getCachedText('Order_Management', 'Placeholder_Dropdown_Menu', 'Select items')" 
              [(ngModel)]="datePosition"
              [sortOrder]="'asc'"
              [sortKey]="'position'"
              [options]="pspos.pointStoreProductAdminOrderFilter.dateCXOne"
              (selectionChanged)="selectionChangedDatePosition();clearFilters()"
              [maxItemsToDisplay]="1000">
            </cxone-singleselect-dropdown>
          </cxone-omnibar-custom-content>
          <!-- filters -->
          <cxone-omnibar-filters>
            <div id="filters-container" class="d-flex justify-content-between bg-light-blue-2 flex-wrap">
              <div class="d-flex flex-wrap">
                <div class="d-block text-start pr-4">
                  <label class="font-size-12 text-uppercase color-label font-weight-600 line-height-16 " cvLocalizedText
                    langSection="Order_Management" langKey="Status">Status</label>
                  <cxone-multiselect-dropdown #statusDropdown
                    id="status-dropdown" 
                    [label]="'name'" class="d-block drodpdown-container"
                    [primaryKey]="'value'"
                    [search]="false"
                    [showFooter]="false"
                    [placeholder]="cvLocalizationService.getCachedText('Order_Management', 'Select_Item', 'Select...')"
                    [sortOrder]="'desc'"
                    [(ngModel)]="selectedStatus"
                    [options]="orderStatusList.newValue"
                    (selectionChanged)="selectionChangedStatus()"
                    [maxItemsToDisplay]="1000">
                  </cxone-multiselect-dropdown>
                </div>
                <!-- <cv-group-selector #groupSelectorDTOComp 
                  [pageName]="'PointStoreAdmin_temp'" 
                  [baseGroupType]="0"
                  [removeTopLevel]="true" 
                  [hasMultiSelect]="true" 
                  [selectedGroupsDto]="selectedAgentsDTO"
                  (selectedGroupsChanged)="onEmpGroupsChanged($event)" 
                  [selectAllOnEmpty]="false"
                  [ariaPlaceholder]="cvLocalizationService.getCachedText('Order_Management', 'Placeholder_Dropdown_Menu', 'Select...')"
                  (selectedGroupsLoaded)="initialGroupsLoaded($event)" 
                  direction="horizontal">
                </cv-group-selector> -->
                <div class="d-block text-start pr-4">
                  <label class="font-size-12 text-uppercase color-label font-weight-600 line-height-16 " cvLocalizedText
                    langSection="Order_Management" langKey="Team_Label">Team</label>
                  <cxone-multiselect-dropdown id="team-dropdown" [label]="'name'" class="d-block drodpdown-container"
                    [primaryKey]="'id'" [placeholder]="cvLocalizationService.getCachedText('Order_Management', 'Select_Item', 'Select...')" [sortOrder]="'asc'" [sortKey]="'name'" [(ngModel)]="selectedTeam"
                    [options]="teamList.newValue" (selectionChanged)="selectionChangedTeam()" [maxItemsToDisplay]="1000">
                  </cxone-multiselect-dropdown>
                </div>
                <div class="d-block text-start pr-4">
                  <label class="font-size-12 text-uppercase color-label font-weight-600 line-height-16 " cvLocalizedText
                    langSection="Order_Management" langKey="Agent_Label">Agent</label>
                  <cxone-multiselect-dropdown #agentDropdown id="agent-dropdown" [label]="'name'" class="d-block drodpdown-container"
                    [primaryKey]="'loginId'" [placeholder]="cvLocalizationService.getCachedText('Order_Management', 'Select_Item', 'Select...')" [sortOrder]="'asc'" [sortKey]="'name'"
                    [(ngModel)]="selectedAgent" [options]="agentList.newValue" (selectionChanged)="selectionChangedAgent()"
                    [maxItemsToDisplay]="1000">
                  </cxone-multiselect-dropdown>
                </div>
              </div>
              <div class="action-btns d-flex align-items-center justify-content-md-end justify-content-lg-end pr-4">
                <a class="pr-2" cvLocalizedText langSection="Order_Management" langKey="Clear_All"
                  (click)="clearFilters()">Clear All</a>
                <a class="pl-2" cvLocalizedText langSection="Order_Management" langKey="Close"
                  (click)="closeFilters()">Close</a>
              </div>
            </div>
          </cxone-omnibar-filters>
          <!-- end filters -->
        </cxone-omnibar>
        <!-- end omnibar and search bar -->
        <!-- /FILTER -->
        <!-- GRID -->
        <div class="mx-auto " 
        [ngClass]="{ 
          'order-management-table-container': !isFilterOpen,
          'order-management-table-container-filters': isFilterOpen,
        }">
          <!-- COMPONENT  -->
          <cxone-order-management-grid (countOrders)="setCountOrdersLabel($event)" [ordersList]="pspos.adminOrders"
            [status]="pspos.pointStoreProductAdminOrderFilter.SelectedStatuses"
            [timeInterval]="pspos.pointStoreProductAdminOrderFilter.datePosition"
            [search]="pspos.pointStoreProductAdminOrderFilter.searchOrder"
            [ordersLoading]="pspos.ordersLoading"
            [selectGroupChange]="pspos.pointStoreProductAdminOrderFilter.groupSelectorChanged"
            [resetFilter]="pspos.pointStoreProductAdminOrderFilter.resetFilter"
            (groupSelectorData)="setGroupSelectorData($event)">
          </cxone-order-management-grid>
        </div>
        <!-- /GRID -->
      </div>
      <!-- /BG COLOR CONTAINER -->
    </div>
  </div>
  <!-- /MAIN CONTAINER -->
</div>